import dayjs from "dayjs"

/**
 * Formats a date-only value ("YYYY-MM-DD") as "Oct 5, 2026".
 *
 * Deliberately does not go through `.utc()`/`.tz()` — these are DRF
 * `DateField`s (project timezone, date-only, no time component), and
 * running one through a timezone-aware parser is exactly the class of bug
 * this app's own KB flags repeatedly (a bare date read a day early). A
 * plain `dayjs("YYYY-MM-DD")` parses as a local calendar date with no
 * shift, which is what a date-only value means.
 */
export const formatPortalDate = (
  value: string | null | undefined
): string | null => (value ? dayjs(value).format("MMM D, YYYY") : null)
